import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ModalsUserseditPage } from './modals-usersedit';

@NgModule({
  declarations: [
    ModalsUserseditPage,
  ],
  imports: [
    IonicPageModule.forChild(ModalsUserseditPage),
  ],
})
export class ModalsUserseditPageModule {}



// WEBPACK FOOTER //
// ./src/pages/modals-usersedit/modals-usersedit.module.ts